import { fetchApi } from '@/config/axiosSetting';
import { ContactInformation } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDriverInfo/driverInfoQuery.type';

export const contactOwnerInitialVisitFunction = (params: {
  data: ContactInformation;
  fileId: string;
}) => {
  return fetchApi.patch(
    `initial/reports/${params.fileId}/insurer_information/contact_information/`,
    params.data,
    {
      params: {
        id: params?.fileId,
      },
    },
  );
};
